import { fieldNameForKey, getFieldsValues, insertColor } from "../helper";
import { ComponentProps, MyStyles } from "../template.interface";

export default function TemplateTextBox(props: ComponentProps) {
  const {
    id = "",
    styles = {},
    componentProps = {},
    content = {},
    wrapperProps = {},
    values = {},
    fields = { static: {}, dynamic: {} },
    isEdit,
    tplVariantId,
  } = props;
  const { url, image, text } = getFieldsValues(content, values, fields, isEdit);
  // Measurement anchors for TS-7. Rendered on every instance, on screen and in the offscreen rig.
  const tplField = fieldNameForKey(content?.text as string | undefined, fields);

  return (
    <div
      style={{
        ...(wrapperProps?.styles
          ? insertColor(wrapperProps.styles as MyStyles, values, fields, isEdit)
          : {}),
      }}
    >
      <p
        style={{
          margin: 0,
          padding: 0,
          ...insertColor(styles as MyStyles, values, fields, isEdit),
        }}
        {...componentProps}
        data-tpl-field={tplField}
        data-tpl-variant={tplVariantId}
      >
        {text}
      </p>
    </div>
  );
}
